export const getCurrency = (value: Number) => {
  return value?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const getNumber = (value:any) => {
  // Remove the dollar sign and commas
  const cleanedString = value.replace(/[$,]/g, '');
  // Convert the cleaned string to a number
  const number = parseFloat(cleanedString);

  return number;
}
 //Format File namer remoivng sepcil cahracters and spaces
 export const parseFileName = (filename)=>{
   filename = filename.replace(/\s+/g, '-');
   return filename.replace(/[^a-zA-Z0-9.-]/g, '');
 }
// A function to format ISO Date to MM/DD/YYYY Date format
export const formatDate = (date: string) => {
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  return `${month}/${day}/${year}`;
}

// A function to format ISO Date to HH:MM AM/PM (12 hour) format
export const formatTime = (date: string) => {
  const dateObj = new Date(date);
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

// Stinr "HH:MM" to "HH:MM AM/PM"
export const formatStringTime = (date: string) => {
  const dateObj = date.split(':');
  const hours = Number(dateObj[0]);
  const minutes = Number(dateObj[1]);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

export const googleDistanceY1X1Y2X2 = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(lat2 - lat1);
  var dLong = rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
    Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var distance = R * c; // distance in meter
  return meters2Miles(distance).toFixed(2);
}

export const meters2Miles = (meters: number) => {
  return meters * 0.000621371;
}

var rad = function (x: number) {
  return x * Math.PI / 180;
};

export const toPascalCase = (str: string) => {
  return str?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter?.toUpperCase());
}

export const getSumOfAttribute = (arr: any[], attr: string) => {
  return arr?.reduce((a, b) => a + (Number(b[attr]) || 0), 0) || 0;
}

export const getCSVStringOfAttribute = (arr: any[], attr: string) => {
  return arr?.map(item => item[attr])?.join(',') || '';
}

export const getCSVStringOfNestedAttributes = (arr: any[], path: string[]) => {
  return arr?.map(item => getNestedValue(item, path))?.join(',') || '';
}

export const getNestedValue = (obj: any, path: string[]) => {
  return path?.reduce((acc, part) => acc && acc[part], obj);
}
